import bPaginationNav from './pagination-nav';
import { registerComponents, vueUse } from '../../utils/plugins';

var components = {
  bPaginationNav: bPaginationNav
};

var VuePlugin = {
  install: function install(Vue) {
    registerComponents(Vue, components);
  }
};

vueUse(VuePlugin);

export default VuePlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/pagination-nav/index.js
// module id = iNir
// module chunks = 1